module.exports = __webpack_public_path__ + "img/icon_dashboard_rule.8aa1e683.svg";